// src/components/MarketSelector.jsx
import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Chip, Box } from '@mui/material';
import axios from 'axios';

const API = process.env.REACT_APP_API_BASE_URL || '';

/**
 * Props:
 *  - sku?: string
 *  - value: { id, code, name, currency_code } | null
 *  - onChange: (marketObj|null) => void
 *  - disabled?: boolean
 *  - label?: string
 */
export default function MarketSelector({ sku, value, onChange, disabled, label = 'Market' }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const params = sku ? { sku } : undefined;
    axios.get(`${API}/api/scrapers/markets`, { params })
      .then(({ data }) => {
        if (!alive) return;
        // data: [{id, code, name, currency_code}]
        setOptions(Array.isArray(data) ? data : []);
      })
      .catch(console.error)
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [sku]);

  const getLabel = (m) => {
    if (!m) return '';
    const name = m.name || '';
    const code = m.code ? ` (${m.code})` : '';
    return `${name}${code}`.trim();
  };

  return (
    <Autocomplete
      options={options}
      loading={loading}
      disabled={disabled}
      value={value || null}
      onChange={(_, v) => onChange?.(v || null)}
      isOptionEqualToValue={(opt, val) => String(opt?.id || '') === String(val?.id || '')}
      getOptionLabel={(opt) => getLabel(opt)}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select a market…" />
      )}
      renderOption={(props, opt) => (
        <Box component="li" {...props} key={opt.id}>
          {opt.name} {opt.code ? <Chip size="small" sx={{ ml: 1 }} label={opt.code} /> : null}
        </Box>
      )}
    />
  );
}
